import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaymentService } from '../../../core/api/payment.service';
import { Payment } from '../../../core/models/payment.model';
import { formatDateTime } from '../../../shared/utils/date.utils';
import { PaymentDeleteDialogComponent } from '../payment-delete-dialog/payment-delete-dialog.component';

@Component({
  selector: 'app-payment-card',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatChipsModule, MatIconModule, MatListModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './payment-card.component.html',
  styleUrl: './payment-card.component.scss',
})
export class PaymentCardComponent {
  @Input() payment!: Payment;
  @Output() deleted = new EventEmitter<void>();

  private dialog = inject(MatDialog);
  private paymentService = inject(PaymentService);
  private snackBar = inject(MatSnackBar);

  protected readonly formatDateTime = formatDateTime;

  onDelete(): void {
    const ref: MatDialogRef<PaymentDeleteDialogComponent, boolean> = this.dialog.open(
      PaymentDeleteDialogComponent,
      { data: { payment: this.payment }, width: '420px' },
    );
    ref.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this.paymentService.delete(this.payment.id).subscribe({
        next: () => {
          this.snackBar.open('Платёж удалён', 'ОК', { duration: 3000 });
          this.deleted.emit();
        },
        error: () => {
          this.snackBar.open('Не удалось удалить платёж', 'ОК', { duration: 5000 });
        },
      });
    });
  }
}
